import React from 'react';

import {ProjectIdChipStyled} from '../styles/components/project_id_chip_styled';
import Util from '../forecast-app/shared/util/util';

const ProjectIdChip = ({projectColor, isProjectGroup, projectId}) => {
	const useDarkText = Util.getTextColor(projectColor) === '#000000';

	return (
		<ProjectIdChipStyled
			useDarkText={useDarkText}
			projectColor={projectColor}
			className={isProjectGroup ? 'project-group' : ''}
		>
			{`${isProjectGroup ? 'X' : 'P'}${projectId}`}
		</ProjectIdChipStyled>
	);
};

export default ProjectIdChip;
